import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectPage } from '../../selectors/analytics';
import { selectHhConversionId } from '../../selectors/cpa';
import { selectUser } from '../../selectors/user';
import { IThunkApi } from '../../types/redux/store';
import { ICallbackClickValues, trackCallbackClick } from '../../utils/analytics';

interface IThunkApiExtended extends IThunkApi {
  rejectValue: void;
}

/**
 * Redux thunk action, отправляющий событие клика на "Заказать звонок" (успешный ответ от сервера)
 */
export const trackCallbackClickAction = createAsyncThunk<void, ICallbackClickValues, IThunkApiExtended>(
  'analytics/trackCallbackClickAction',
  async (values, { getState, extra: context }) => {
    try {
      const state = getState();
      const page = selectPage(state);
      const user = selectUser(state);
      const hhConversionId = selectHhConversionId(state);

      trackCallbackClick({ page, user, values, hhConversionId });
    } catch (ex) {
      const { logger } = context;
      logger.error(ex, {
        domain: 'thunks/analytics/trackCallbackClickAction',
      });

      throw ex;
    }
  },
);
